import React, { useRef } from 'react';
import Nomination from './Nomination';
import Modal from '../../2_Molecules/Modal/Modal';

interface FormExtraParams {
  language: string;
  source: string;
  formHeading: string;
  formDisclaimer: string;
  formSubmitButtonText: string;
  formSubmitUrl: string;
  formImage?: string;
  isPopUp?: string;
}

interface NominationModalProps {
  formExtraParams: FormExtraParams;
}

const NominationModal: React.FC<NominationModalProps> = ({ formExtraParams }) => {
  const { formImage, isPopUp, ...restParams } = formExtraParams;
  const isPopUpBoolean = (isPopUp && isPopUp.toLowerCase() === 'true');
  const modalRef = useRef<HTMLDivElement>(null);

  return (
    <Modal
      className={`mz-kmi-modal ${isPopUpBoolean ? 'mz-popup-modal' : ''}`}
      isDark={true}
      modalRef={modalRef}
    >
      <Nomination
        formExtraParams={restParams}
      />
    </Modal>
  );
};

export default NominationModal;
